const ACTIVELY_SENDING_STATUSES = new Set(["PENDING", "PROCESSING"]);

/**
 * Poll every 5s while a broadcast is actively sending (so successCount/failureCount and
 * per-recipient delivery status update live on the Show page); stop once it reaches a terminal
 * status (COMPLETED/FAILED/CANCELLED) so we're not polling a broadcast that's done.
 */
export function getBroadcastStatusPollIntervalMs(
  status: string | null | undefined
): number | false {
  return status != null && ACTIVELY_SENDING_STATUSES.has(status) ? 5000 : false;
}
